var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlobHaikei(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 675",
    width: 900,
    height: 675,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400.8807785891734 321.46685938106066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.5 -166.1C231.8 -119.3 284.6 -59.6 294.3 9.7C304 79 270.4 157.9 214.2 212.6C157.9 267.3 79 297.6 8.5 289.1C-62 280.7 -124 233.3 -152.1 178.6C-180.2 124 -174.5 62 -182.4 -7.9C-190.3 -77.8 -211.8 -155.6 -183.7 -202.4C-155.6 -249.2 -77.8 -265.1 -9.1 -256C59.6 -247 119.3 -212.9 175.5 -166.1",
    fill: "#715DF2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobHaikei);
export default __webpack_public_path__ + "static/media/blob-haikei.e8c38cbfe171f92cea138505e21d8881.svg";
export { ForwardRef as ReactComponent };